import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "main", "view", "list", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `users--works--permissions--features--dashboard`
  }

  doFeaturesDashboard() {
    var html = `<div class="row" data-${this.controllerName}-target="mainDashboard">
                  <div class="col-8 pr-1" data-${this.controllerName}-target="list" data-controller="users--works--permissions--features--index"></div>
                  <div class="col-4 pl-1" data-${this.controllerName}-target="view" data-controller="users--works--permissions--features--save users--works--permissions--features--show"></div>
                </div>`

    this.getControllerByIdentifier(`users--works--permissions--entities--main`).contentTarget.innerHTML = html
    
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
